'use strict';

var define = require('define-properties');
var ES = require('es-abstract/es6');

var implementation = require('./implementation');
var getPolyfill = require('./polyfill');
var shim = require('./shim');

var slice = Array.prototype.slice;

var boundShim = function findIndex(array, predicate) {
	ES.RequireObjectCoercible(array);
	return implementation.apply(array, predicate);
};

define(boundShim, {
	implementation: implementation,
	getPolyfill: getPolyfill,
	shim: shim
});

module.exports = boundShim;



/*****************
 ** WEBPACK FOOTER
 ** ./~/array.prototype.findindex/index.js
 ** module id = 109
 ** module chunks = 0
 **/